import { render } from "./SettingsHomeImagesForm.vue?vue&type=template&id=1ca2de73&scoped=true"
import script from "./SettingsHomeImagesForm.vue?vue&type=script&lang=js"
export * from "./SettingsHomeImagesForm.vue?vue&type=script&lang=js"

import "./SettingsHomeImagesForm.vue?vue&type=style&index=0&id=1ca2de73&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2de73"]])

export default __exports__